import { EditClientProduct } from './EditClientProduct'

export default EditClientProduct
